export function containsSpecialCharacters(value) {
	var format = /[`#^_+\-=[\]{}|\\<>/~]/
	return !format.test(value)                                   
}

export function containsOnlyDigits(value) {
	var format = /[^0-9]+/g
	return !format.test(value)                                   
}